module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm2_m.28f01ec1f7cdac4140f482a4da5f78c3.png";